// © Microsoft Corporation. All rights reserved.

/**
 * Converts the given error object to its string representation based on
 * the type of the input object.
 * @param error - the error object to convert to a string.
 * @returns {string} - The string representation of the error.
 */
export function stringifyError(error: string | object | Error): string {
    return (error instanceof Error)
        ? error.toString()
        : typeof error === "string"
            ? error
            : JSON.stringify(error);
}